import styled from "styled-components";

export const Title = styled.h2`
   font-size: 36px;
   font-weight: 700;
   line-height: 50px;
   text-align: center;
   color: #2A2637;
   margin-bottom: 48px;
   @media(max-width: 600px) {
     text-align: left;
     width: 200px;
     line-height: 33px;
     margin-bottom: 32px;
     margin-top: 20px;
   } 
`

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 15px;
   } 
`

export const Content = styled.div`
   height: 605px;
   width: 850px;
   display: flex;
   flex-flow: column wrap;
   align-items: flex-start;
   margin-bottom: 32px;
   @media(max-width: 850px) {
     width: 100%;
   } 
   @media(max-width: 768px) {
     height: 760px;
   }      
`

export const Text = styled.div`
   font-size: 18px;
   font-weight: 400;
   line-height: 29px;
   color: #2A2637;
   margin-bottom: 17px;
   margin-left: 60px;
   margin-right: 60px;
   @media(max-width: 768px) {
     font-size: 14px;
     line-height: 22.4px;
   }
   @media(max-width: 600px) {
     margin-left: 0px;
     margin-right: 35px;
   }
`

export const Link = styled.a`
  @media(max-width: 768px) {
    font-size: 14px;
  }
  font-size: 18px;
  font-weight: 500;
  line-height: 29px;
  color: #0D71D7;
  cursor: pointer
`

export const TitleBlock = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 39px;
  text-align: center;
  color: #2A2637;
  margin-bottom: 36px;
  @media(max-width: 768px) {
     font-size: 20px;
  } 
`

export const Block = styled.div`
  width: 743px;
  height: 398px;
  padding: 36px 48px 56px 48px;
  border-radius: 32px;
  border: 1px solid #C4BFD4;
  margin-top: 48px;
  @media(max-width: 768px) {
    width: 100%;
    height: 100%;
    padding: 32px 48px 32px 48px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 282px;
  height: 58px;
  margin-bottom: 28px;
  @media(max-width: 600px) {
     width: 238px;
     margin-bottom: 24px;
   } 
`

export const WrapperText = styled.div`
   font-size: 18px;
   font-weight: 400;
   line-height: 29px;
   color: #2A2637;
   @media(max-width: 768px) {
     font-size: 14px;
     width: 100%;
   } 
`

export const WrapperBlock = styled.div`
  display: flex;
  @media(max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 20px;
`

export const Indent = styled.div`
  width: 80px;
  @media(max-width: 768px) {
    width: 0px;
  }
`




